import { useState, type ChangeEvent, useEffect } from 'react';
import { useDebounce } from '@/hooks/useDebounce';
import useUpdateJobChangeProcessNote from '../../api/useUpdateJobChangeProcessNote';
import { Textarea } from '@/components/Textarea';

type Props = {
  id: number;
  note: string;
};

export default function JobChangeProcessNote({ id, note }: Props) {
  const debounce = useDebounce(500);
  const { mutateAsync } = useUpdateJobChangeProcessNote();
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(note);

  // NOTE: propsのnoteが変更された時にローカルの状態を同期
  useEffect(() => {
    setValue(note);
  }, [note]);

  const onChangeNote = (event: ChangeEvent<HTMLTextAreaElement>) => {
    const value = event.currentTarget.value;
    setValue(value);

    debounce(async () => {
      await mutateAsync({ jobChangeProcessId: id, note: value });
    });
  };

  return (
    <div className="overflow-hidden">
      {!isEditing ? (
        <div className="h-[62px] max-h-[62px] rounded border border-solid border-border bg-white p-2">
          <div
            className="line-clamp-2 h-[39px] cursor-pointer overflow-hidden text-xs leading-[170%] tracking-normal break-words"
            onClick={(e) => {
              e.stopPropagation();
              setIsEditing(true);
            }}
          >
            {value}
          </div>
        </div>
      ) : (
        <Textarea
          className="h-[62px] min-h-[62px] w-full resize-none border-2 border-border p-2 text-xs leading-[170%] tracking-normal"
          name="note"
          id="note"
          value={value}
          onChange={(e) => {
            e.stopPropagation();
            onChangeNote(e);
          }}
          onBlur={() => setIsEditing(false)}
          onClick={(e) => {
            e.stopPropagation();
          }}
          autoFocus
        />
      )}
    </div>
  );
}
